letterAdjust.scale = 0.8;
letterAdjust.use_number_outline = true;
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
    "0": "M86 -125v1049l142 141h467l141 -141v-1049l-141 -141h-467zM286 -66h350v931h-350v-931z",
    "1": "M85 -66h148v818h-148v113l148 200h200v-1131h147v-200h-495v200z",
    "2": "M88 121l550 579v165h-327l-114 -113h-109v172l141 141h467l140 -141v-304l-549 -579v-107h549v-200h-748v387z",
    "3": "M86 47h110l114 -113h325v366h-239v199h239v366h-325l-114 -113h-110v172l142 141h467l140 -141v-434l-91 -91l91 -90v-434l-140 -141h-467l-142 141v172z",
    "4": "M16 71v199l512 795h253v-795h123v-199h-123v-337h-199v337h-566zM254 270h328v509z",
    "5": "M89 47h109l115 -113h326l-1 366h-549v765h748v-200h-548v-366h408l140 -141v-483l-140 -141h-467l-141 141v172z",
    "6": "M86 -125v1049l142 141h467l141 -141v-172h-111l-113 113h-326v-366h409l141 -141v-483l-141 -141h-467zM286 -66h350v366h-350v-366z",
    "7": "M80 752v313h748v-355l-430 -976h-219l450 1018v113h-349v-113h-200z",
    "8": "M86 -125v434l91 90l-91 91v434l142 141h467l141 -141v-434l-92 -91l92 -90v-434l-141 -141h-467zM286 -66h350v366h-350v-366zM286 499h350v366h-350v-366z",
    "9": "M86 47h110l114 -113h326v366h-408l-142 141v483l142 141h467l141 -141v-1049l-141 -141h-467l-142 141v172zM286 499h350v366h-350v-366z",
    "A": "M53 -266l188 1331h390l188 -1331h-227l-40 297h-232l-40 -297h-227zM350 257h172l-79 581h-15z",
    "B": "M89 -266v1331h519l114 -113v-497l-58 -56l58 -57v-495l-114 -113h-519zM315 -40h180v326h-180v-326zM315 512h180v326h-180v-326z",
    "C": "M88 -153v1105l113 113h406l113 -113v-186h-226v72h-180v-878h180v156h226v-269l-113 -113h-406z",
    "D": "M89 -266v1331h519l114 -113v-1105l-114 -113h-519zM315 -40h180v878h-180v-878z",
    "E": "M89 -266v1331h633v-227h-407v-326h180v-226h-180v-326h407v-226h-633z",
    "F": "M89 -266v1331h633v-227h-407v-326h180v-226h-180v-552h-226z",
    "G": "M88 -153v1105l113 113h406l113 -113v-186h-226v72h-180v-878h180v326h-90v226h316v-665l-113 -113h-406z",
    "H": "M89 -266v1331h226v-553h180v553h227v-1331h-227v552h-180v-552h-226z",
    "I": "M89 -266v1331h226v-1331h-226z",
    "J": "M34 116h227v-156h180v1105h226v-1218l-113 -113h-406l-114 113v269z",
    "K": "M89 -266v1331h226v-514l268 514h254l-263 -507l263 -824h-236l-174 542l-112 -215v-327h-226z",
    "L": "M89 -266v1331h226v-1105h407v-226h-633z",
    "M": "M89 -266v1331h226l156 -520l158 520h226v-1331h-226v665l-158 -520l-156 520v-665h-226z",
    "N": "M89 -266v1331h226l180 -590v590h227v-1331h-227l-180 590v-590h-226z",
    "O": "M88 -153v1105l113 113h406l113 -113v-1105l-113 -113h-406zM314 -40h180v878h-180v-878z",
    "P": "M89 -266v1331h519l114 -113v-553l-114 -113h-293v-552h-226zM315 512h180v326h-180v-326z",
    "Q": "M88 -153v1105l113 113h406l113 -113v-1105l-113 -113h-52l35 -101h-129l-35 101h-225zM314 -40h34l-26 74h129l25 -74h18v878h-180v-878z",
    "R": "M89 -266v1331h519l114 -113v-553l-114 -113l114 -552h-232l-113 552h-62v-552h-226zM315 512h180v326h-180v-326z",
    "S": "M88 33h226v-73h180v326h-293l-113 113v553l113 113h406l113 -113v-186h-226v72h-180v-326h293l113 -113v-552l-113 -113h-406l-113 113v186z",
    "T": "M75 838v227h632v-227h-203v-1104h-226v1104h-203z",
    "U": "M89 -153v1218h226v-1105h180v1105h227v-1218l-114 -113h-406z",
    "V": "M69 1065h227l90 -529l89 529h226l-226 -1331h-179z",
    "W": "M72 1065h226l79 -585l138 585h12l139 -585l78 585h226l-178 -1331h-200l-70 382l-72 -382h-200z",
    "X": "M81 -266l202 665l-202 666h226l91 -294l90 294h226l-203 -666l203 -665h-226l-90 294l-91 -294h-226z",
    "Y": "M64 1065h236l147 -501l146 501h236l-269 -919v-412h-226v412z",
    "Z": "M89 -40l406 878h-406v227h633v-227l-407 -878h407v-226h-633v226z"
};
var font_size = 24,
    tracking = 2,
    panel_Hor_Adjustment = 2.5,
    font_Top_Adjustment = -15.5,
    middleSplitAdjustment = -2.5,
    middleSpreadAdjustment = {
        left: 0.75,
        right: 0.75
    },
    small_Caps_Adjustment = {
        vertical: -180,
        horizontal: 0,
        scale_width: 0, // effects period
        scale_height: 0, // effects period
    },
    colors = {
        characters: {
            home: [
                "#FFFFFF", // white
            ],
            away: [
                "#00508F", // blue
            ]
        },
        numbers: {
            home: [
                "#FFFFFF", // white
                "#231F20", // black
                "#FFFFFF", // white
            ],
            away: [
                "#00508F", // blue
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.5
        },
        numbers: {
            width: 2.5
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 0.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 11,
        left: -7,
        width: 90,
        height: 75,
        middle_Space: 6,
    };
